import { render, staticRenderFns } from "./UploadChatFile.vue?vue&type=template&id=5f20f2ee"
import script from "./UploadChatFile.vue?vue&type=script&lang=js"
export * from "./UploadChatFile.vue?vue&type=script&lang=js"
import style0 from "./UploadChatFile.vue?vue&type=style&index=0&id=5f20f2ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports